module.exports = __webpack_public_path__ + "static/media/slider_next_white.3227108f.png";